import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { NewsletterForm } from "@/components/NewsletterForm";
import { useT } from "@/i18n";

const COLS = [
  ["Tools", [["/grader", "Listing Grader"], ["/house-rules", "House Rules Generator"], ["/tourist-tax", "Tourist tax calculator"], ["/app", "HostScribe app"], ["/pricing", "Pricing"]]],
  ["Guides", [["/guides/country/spain", "Spain"], ["/guides/country/portugal", "Portugal"], ["/guides/country/italy", "Italy"], ["/guides/country/france", "France"], ["/guides/country/greece", "Greece"], ["/guides/country/croatia", "Croatia"]]],
  ["Company", [[process.env.REACT_APP_PARENT_URL, "KINGBORNSYSTEM"], ["/templates", "Templates shop"], ["/help", "Help center"], ["/legal/terms", "Terms"], ["/legal/privacy", "Privacy & GDPR"], ["/legal/imprint", "Imprint"]]],
];

export const Footer = () => {
  const { t } = useT();
  return (
  <footer className="bg-[#0F4C5C] text-[#F4E9D8] py-20 no-print" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
      <div>
        <Logo light />
        <p className="mt-4 max-w-sm text-[#F4E9D8]/80 text-sm leading-relaxed">{t("Your listing, written like a pro. In every language. Host-to-host tools for European short-term rentals.")}</p>
        <p className="mt-8 font-display text-lg">{t("The Tuesday host letter")}</p>
        <p className="text-sm text-[#F4E9D8]/70 mb-3">{t("1 tip, 1 template, 1 tool. Every Tuesday.")}</p>
        <NewsletterForm dark testid="footer-newsletter" />
      </div>
      {COLS.map(([title, links]) => (
        <div key={title}>
          <p className="text-xs uppercase tracking-widest text-[#F4E9D8]/60 mb-4">{t(title)}</p>
          <ul className="space-y-2.5">
            {links.map(([to, label]) => (
              <li key={to}>{to.startsWith("http") ? <a href={to} target="_blank" rel="noreferrer" className="text-sm hover:text-[#E36414] transition-colors" data-testid="footer-parent-link">{label}</a> : <Link to={to} className="text-sm hover:text-[#E36414] transition-colors">{t(label)}</Link>}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16 pt-6 border-t border-[#F4E9D8]/15 text-xs text-[#F4E9D8]/60 flex flex-wrap justify-between gap-4">
      <span>{t("© 2026 HostScribe, a KINGBORNSYSTEM product · Terzigno (NA), Italy. Not affiliated with Airbnb or Booking.com.")}</span>
      <span>{t("Data hosted in the EU · AI drafts are checked by you, not replaced by us.")}</span>
    </div>
  </footer>
  );
};
